export { default as UserTermsModalBody } from './UserTermsModalBody';
